export default __webpack_public_path__ + "static/media/57.053e234b.svg";